import React from 'react'

export default function Power() {
    return (
        <div>
            <svg width="54" height="54" viewBox="0 0 54 54" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clip-path="url(#clip0_178_5516)">
                    <path d="M31.5 27H22.5V0H31.5V27ZM40.9792 3.9465L38.25 7.54425C44.964 11.4412 49.5 18.693 49.5 27C49.5 39.4065 39.4065 49.5 27 49.5C14.5935 49.5 4.5 39.4065 4.5 27C4.5 18.693 9.036 11.4412 15.75 7.54425L13.0208 3.9465C5.2245 8.67825 0 17.2148 0 27C0 41.9108 12.0893 54 27 54C41.9108 54 54 41.9108 54 27C54 17.2148 48.7755 8.67825 40.9792 3.9465Z" fill="#BB0600" />
                </g>
                <defs>
                    <clipPath id="clip0_178_5516">
                        <rect width="54" height="54" fill="white" />
                    </clipPath>
                </defs>
            </svg>

        </div>
    )
}
